module.exports = __webpack_public_path__ + "static/ipad-a904232cdaa0b83df8e5ae2e2f0068fe.png";